// extracted by mini-css-extract-plugin
export var container = "_5g-1";
export var cornerButtonContainer = "_5g-5";
export var disabled = "_5g-2";
export var fileContainer = "_5g-4";
export var hiddenInput = "_5g-3";
export var widthContainer = "_5g-0";